import { render, staticRenderFns } from "./CustomerSection.vue?vue&type=template&id=474a06c1&scoped=true&"
import script from "./CustomerSection.vue?vue&type=script&lang=js&"
export * from "./CustomerSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a06c1",
  null
  
)

export default component.exports